import axiosPost from '../axiosPost';

export const conciliacionHTGet = async (arg) => {
    const { id } = arg

    const body = {
        "service": "BindConciliacionHTGet",
        "params": {
            "movtranTransaccionBIND": id
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    };
};